var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.57025 157.99829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 1.11053,
    height: 1.82809,
    x: -0.05527,
    y: -0.41405,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.76952
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    paintOrder: "markers fill stroke",
    transform: "translate(-33.86741 -86.15571)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39ae24",
    d: "M160.87157 223.52324c-3.57126 5.25416-4.0259 9.89264-1.36393 13.91543l4.98985-1.86055-.39238 1.93079 8.05587-3.43634-.0968 2.36909 7.50835-4.06769.0797 1.95051 9.78543-3.12074-9.08335-4.51698-.23759 2.42406-7.00325-4.06504-.31683 2.54245-6.78251-3.81243-.12866 2.00265M61.38482 211.34613c-3.3227 5.13601-7.39106 7.36829-12.20507 6.69684l-.39044-4.99681-1.60804 1.1025-.23313-8.23914-2.13487 1.0246.57697-8.02307-1.8247.70762-1.25051-9.58917 7.96904 5.9532-2.12611 1.16659 6.679 4.3583-2.2015 1.28128 6.35417 4.27044-1.78497.90606M137.69381 208.93323c-7.03244.002-12.36789-1.89472-16.00635-5.69133l3.69548-2.62303-2.28663-.6467 6.45-4.028-2.68125-1.06426 6.97906-3.34082-2.15596-.98839 6.65654-5.39629 2.11374 8.55282-2.78828-.99142 2.2812 6.87261-2.94636-.99224 2.07005 6.5965-2.28168-.86669"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.13155,
    cy: 232.99876,
    fill: "#33291f",
    filter: "url(#a)",
    opacity: 0.57768,
    rx: 60.13464,
    ry: 8.02672,
    transform: "matrix(1.15172 0 0 .78477943 -16.05972 48.57557)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6e8b9",
    d: "M179.9773 208.19917s-20.01452 28.05433-27.38332 29.50177c-7.3688 1.44744 1.15714 2.35295-8.85119.74436s-8.61893.26159-14.00351.74436c-7.11455.37904-30.70261-10.61225-38.33458-8.11212-7.50436 2.45833-19.43671 2.83945-36.5213 2.2796-10.26369.52634-9.30451-13.02631-9.30451-13.02631 0-4.73708 12.82875-26.797 12.82875-26.797 10.26369-38.68618 6.31505-70.54079-1.84326-97.38427l75.11192.08643s-22.15712 75.78421-15.70769 83.15499c6.44943 7.37078 20.20873 17.86066 23.6802 19.86491 3.47147 2.00426 15.70073 3.10903 17.41134 2.97744 1.71061-.13158 19.72556-14.14286 19.72556-14.14286s10.2669-.97787 10.79324 7.44361c.9211 4.47391-2.86457 7.92801-7.60165 12.66509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.25277,
    d: "m80.55301 121.08139-12.36905-4.7399s2.54527 56.04026.17673 64.72491c-2.36855 8.68466 7.30494-.18664 8.35762-8.08178 1.05269-7.89514 17.25644-49.82204 3.8347-51.90323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7d395",
    d: "m183.23303 204.81308-2.40144 2.63171-13.25725.0987s12.56643-3.45412 15.65869-2.7304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6e8b9",
    d: "M167.25838 221.28297s11.09631 1.19344 14.44574-1.59433c3.34942-2.78778 6.51307-6.94257 3.67216-11.22306-2.84092-4.28049-18.10105-.68259-18.10105-.68259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7d395",
    d: "M162.24384 214.94226s9.97898-2.63485 19.94459 4.26283c.15837.10962-1.11985 1.15969-2.71882 1.57558-5.87484 1.52803-14.74706-4.29348-14.74706-4.29348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6e8b9",
    d: "M158.54685 228.04098s10.49347 3.79992 14.41012 1.88936c3.91664-1.91056 7.97818-5.19307 6.23759-10.02668-1.7406-4.8336-17.41854-4.97078-17.41854-4.97078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7d395",
    d: "M172.95697 229.93034s-12.72634-8.31621-20.14093-4.59934c-10.83474 5.43137 17.26984 5.1357 17.26984 5.1357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6e8b9",
    d: "M145.75207 238.56472s11.77951 4.0447 16.17617 2.01106c4.39665-2.03363 8.95596-5.52759 7.00205-10.67256-1.95392-5.14497-19.5533-5.29099-19.5533-5.29099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c0d173",
    d: "m175.48308 218.65601-3.81485 3.25658 4.7453 2.51222 2.04699-3.44267zM163.81243 228.48957l-3.30961 3.37885 2.97744 2.32613 1.48872-1.0235-.93045-1.20959 2.14004.37218 1.72657-1.99195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616d30",
    d: "M184.94364 180.60132c.477-.19738.62503.0493.80597.24671l-3.99692 4.27655-.25045-1.63598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c0d173",
    d: "M169.41653 193.6283s9.71179-10.14258 15.52711-13.02698c-1.48872 1.90742-1.11848 6.19017.46055 8.16396l-15.06655 12.30326s-1.90801-5.72963-.92111-7.44024zM183.03565 208.36589l-3.09226 3.55281-5.72398-1.38165 2.7633-2.6975z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.21533,
    cy: 96.15524,
    fill: "#a7d395",
    rx: 37.50191,
    ry: 6.4477
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.39401,
    cy: 96.19096,
    fill: "#e78686",
    rx: 34.61309,
    ry: 5.38912
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.10354,
    cy: 95.66179,
    fill: "#fffacf",
    rx: 15.93557,
    ry: 2.51677
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39ae24",
    d: "M87.03035 235.36981c-8.52633 4.57264-12.44857 4.15416-20.3269 2.46639l1.85453-7.08594-2.87062.83822 3.65452-11.50804-3.59829.50484 4.7268-10.86209-2.99404.19871 2.83072-13.81288 8.69272 11.65433-3.65439.70518 7.59145 8.89374-3.81949.83176 7.16208 8.63304-3.03249.49046M128.77478 243.302c8.17713 1.23055 12.97496 1.49243 21.27884-1.72659l-4.07308-5.90766 2.97174-.27388-6.92161-6.68665 3.56096-.71114-7.74338-5.93812 2.89645-.74086-6.83389-8.48039-4.73288 10.39268 3.67433-.59252-4.51926 8.21078 3.8688-.55551-4.19083 7.90967 3.02058-.55547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6e8b9",
    d: "m71.70378 101.87118-1.33823-5.93329 3.3875 1.13485 3.17294-1.07002 1.09531 6.61612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7d395",
    d: "M122.30853 92.20534s2.13861-4.5035 2.33599-6.04963l1.54613 2.53302 1.64482-2.00668s2.50013 3.91468.19738 6.90825"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a7d395",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m77.9718 101.95418-.97697-5.95489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c6e8b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M127.82072 86.72968s2.34939 3.69854.33729 6.66435"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#086415",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.527,
    d: "m118.87107 136.38033 5.71042 2.1186M67.17857 161.87469l-5.02444-1.30263M114.82508 153.58512l4.83835 3.53572M62.34022 111.28195l-3.44267 1.11654M124.49436 111.28195l4.63903 2.29694M70.5282 119.28383l-3.53572 1.67482M71.44674 142.9054l-4.5592.8374M103.28007 134.14725l4.28008 2.23308M98.73276 115.0849l4.65226.93045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.297,
    d: "M182.71168 185.1031s-1.95395.17884-2.38816 1.43078c-.43421 1.25193-1.21579 2.41443-2.38815 3.08511-1.17237.67068-2.73553 1.07308-3.43027 1.96732-.69473.89423-1.34605 3.12983-2.17105 3.44281-.82499.31298-1.99736-1.02837-.91184-1.65434 1.08553-.62596 2.86579-3.57694 4.34211-4.06877 1.4763-.49184 2.6921-1.65434 3.34341-2.81685.65131-1.1625 4.90657-4.73945 3.60395-1.38606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M146.82518 95.14707s1.53033-2.78885 3.15068-1.59363 2.47553 3.58566 2.47553 3.58566-2.02543-3.66534-5.62621-1.99203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M157.89756 95.14707s-1.53033-2.78885-3.15068-1.59363-2.47553 3.58566-2.47553 3.58566 2.02543-3.66534 5.62621-1.99203zM170.88817 89.8554s-.74577-2.78884-1.53541-1.59362c-.78965 1.19521-1.2064 3.58565-1.2064 3.58565s.98705-3.66534 2.74181-1.99203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M162.70019 89.8554s1.53033-2.78884 3.15068-1.59362c1.62035 1.19521 2.47553 3.58565 2.47553 3.58565s-2.02543-3.66534-5.62621-1.99203zM171.34729 105.7304s1.06657-2.78884 2.19589-1.59362c1.12931 1.19522 1.72533 3.58565 1.72533 3.58565s-1.41164-3.66534-3.92122-1.99203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M179.06424 105.7304s-1.06657-2.78884-2.19588-1.59362c-1.12931 1.19522-1.72533 3.58565-1.72533 3.58565s1.41163-3.66534 3.92121-1.99203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#086415",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.41165,
    d: "m113.52173 120.44765 3.96486 1.86176"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/foot.66940cd8a7e3f822c7838edebd2737f6.svg";
export { ForwardRef as ReactComponent };